import { Alert, Code } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

import { RawBlock } from '@/types';

interface RawBlockViewProps {
  block: RawBlock;
}

export function RawBlockView({ block }: Readonly<RawBlockViewProps>) {
  return (
    <Alert variant="light" color="orange" icon={<IconAlertTriangle size={16} />} title="Raw Jinja">
      This piece couldn&apos;t be converted to a visual block. To edit it, open the template in
      Advanced mode.
      <Code block mt="xs" style={{ fontSize: 11 }}>
        {block.source}
      </Code>
    </Alert>
  );
}
